module.exports = __webpack_public_path__ + "img/TUR-i-1-II.4d4c1b64.png";